export default __webpack_public_path__ + "static/media/back.dfccd240.svg";